import { translationsFactory } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';

export const Translations = translationsFactory(
  '/api/ks/translations',
  ExportTags.TRANSLATION_GRID
);
